import entryguideService from '../../services/entryguideService'

const state = {
    entryguide: []
}

const getters = {
    entryguide: state => {
        return state.entryguide
    }
}

const actions = {
    getEntryguide({ commit}, params) {
        entryguideService.fetchEntryguide(params)
        .then(entryguide => {
            commit('setEntryguide', entryguide)
        })
    },
    
    editEntryguide({commit}, entryguide){
        entryguideService.putEntryguide(entryguide[1],entryguide[0])        
        
        .then((entryguide) => {
            commit('editEntryguide', entryguide)
        })
    },
}
    


const mutations = {
    setEntryguide (state, entryguide) {
        state.entryguide = entryguide
    },
    editEntryguide (state, entryguide) {
        let record = state.entryguide.results.findIndex(element => {return element.id == entryguide.id})
        state.entryguide.results[record] = entryguide
    },
}

export default {
    namespaced:true,
    state,
    getters,
    actions,
    mutations
}